<template> 
  <div class="delivery-form-details-line" >
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.tmod}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.tlib_mod}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.ttaille}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.tcol_tmarq}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.topt}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.tqte_bl}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span><router-link :to="{name: 'detailorder', params: {order_id: lineData.tncde}}">{{lineData.tncde}}</router-link></span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.tref}}</span>
    </div>
    <div class="delivery-form-details-line-cell">
      <span>{{lineData.trefc}}</span>
    </div>
  </div>

</template>

<script>
export default {
  props: ['dataline', 'index'],
  name:'DeliveryFormDetailsLine',
  data() {
    return {
      lineData: {
        tmod: this.$props.dataline.TMOD,
        tlib_mod: this.$props.dataline.TLIB_MOD,
        ttaille: this.$props.dataline.TTAILLE,
        tcol_tmarq: this.$props.dataline.TCOL+'-'+this.$props.dataline.TMARQ,
        topt: this.$props.dataline.TOPT,
        tqte_bl: this.$props.dataline.TQTE_BL+' '+ this.$props.dataline.TUNIT_QTE,
        tncde: this.$props.dataline.TNCDE,
        tref: this.$props.dataline.TREF,
        trefc: this.$props.dataline.TREFC,
      } 
    }
  }
}
</script>

<style scoped>
.delivery-form-details-line {
  display: flex;
  border: solid 1px #E9E9E9;
  margin-top: 10px;
  transition: all .3s;
  align-items: center;
}
.delivery-form-details-line-cell {
  display: flex;
  width: calc(100% / 9);
  justify-content: center;
  padding: 25px 0px;
}
.delivery-form-details-line-cell span {
  color:#585858;
  font-size: var(--fz-md);
  transition: all .3s;
}
.delivery-form-details-line:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}
.delivery-form-details-line:hover .delivery-form-details--line-cell span {
  color: #8B8B8B;
}
</style>